<!--
 * @Author: 'llhj' llhj0326@163.com
 * @Date: 2023-09-07 14:02:39
 * @LastEditors: 'llhj' llhj0326@163.com
 * @LastEditTime: 2025-09-10 12:00:44
 * @FilePath: \front\src\views\System\sms\smsSend.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="about">
		<div class="pg-header">
			<div>
				<label class="title">短信模版</label>
			</div>
			<div class="algr">
				<div class="pg-nav">
					<i class="icon-home"></i>
					<span>系统管理</span>|
					<span>短信模版</span>
				</div>
			</div>
		</div>
		<div class="collapse-wrap">
			<div class="search-bar">
				<el-form ref="form" label-width="120px">
					<div class="def-key">
						<label>模版名称
							<el-input size="small" placeholder="模版名称" clearable v-model="filter.templateName"
								@change="handleFilter($event)"></el-input>
						</label>
						<div style="display: inline-block;">模版类型
							<el-select size="mini" v-model="filter.templateType" placeholder="请选择"
								@change="handleFilter($event)" filterable clearable>
								<el-option label="复诊短信" value="2" style="width:180px"></el-option>
								<el-option label="随访短信" value="1" style="width:180px"></el-option>
							</el-select>
						</div>
						<el-button size="mini" icon="el-icon-search" round @click="handleFilter">搜索</el-button>
					</div>
				</el-form>
			</div>

			<div class="table-wrap">
				<div class="action-bar">
					<el-button type="primary" size="mini" round @click="showDlg(1)">新增模版</el-button>
					<el-button type="danger" size="mini" round @click="delItem">批量删除</el-button>
				</div>
				<el-table ref="multipleTable" header-cell-class-name="tab-cell" cell-class-name="tab-cell" border
					:data="list.data" v-loading="isLoading" @selection-change="selectionChange">
					<el-table-column fixed="left" type="selection" width="55"></el-table-column>

					<el-table-column prop="templateName" label="短信模版名称"></el-table-column>
					<el-table-column prop="smsTypeStr" label="模版类型">
						<template slot-scope="scope">
							{{ scope.row.templateType == 1 ? '随访类型' : scope.row.templateType == 2 ? '复诊类型' : '' }}
						</template>
					</el-table-column>
					<el-table-column prop="creatorName" label="创建人"></el-table-column>
					<el-table-column prop="createTime" label="创建时间"></el-table-column>
					<el-table-column fixed="right" label="操作" width="200">
						<template slot-scope="scope">
							<div class="tab-action">
								<el-tooltip content="修改" placement="top" :enterable="false"><i class="el-icon-edit-outline"
										@click="showDlg(2, scope.row)"></i></el-tooltip>
								<el-popconfirm confirmButtonText='删除' title="确定删除吗？" @confirm="delItem('one', scope.row)">
									<el-tooltip content="删除" slot="reference" placement="top" :enterable="false"><i
											class="el-icon-delete"></i></el-tooltip>
								</el-popconfirm>
							</div>
						</template>
					</el-table-column>
				</el-table>
				<div class="pagination">
					<el-row>
						<el-col :span="12">
							<div class="record">当前是第<span
									v-text="(filter.pageNumber - 1) * filter.pageSize + 1"></span>条至第<span
									v-text="Math.min(list.total, (filter.pageNumber - 1) * filter.pageSize + filter.pageSize)"></span>数据
							</div>
							<div class="record">总计<span v-text="list.total"></span>条记录</div>
						</el-col>
						<el-col :span="12" style="text-align: right;">
							<el-pagination :disabled="isLoading" layout="sizes, prev, pager, next"
								:page-sizes="[10, 20, 30, 40, 50, 60, 70, 80, 90, 100]" prev-text="上一页" next-text="下一页"
								:current-page="list.current" :page-size="filter.pageSize" :total="list.total"
								@size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
						</el-col>
					</el-row>
				</div>
			</div>

		</div>
		<el-dialog :title="dlg.title" width="600px" center :visible.sync="dlg.active" custom-class="dlg-custom"
			@close="closeDlg">
			<el-form ref="form" label-width="120px" :rules="dlg.rule" :model="form">
				<el-form-item label="模版类型" prop="templateType">
					<el-select size="small" v-model="form.templateType" placeholder="请选择模版类型" filterable clearable>
						<el-option label="随访短信" :value="1" style="width:257px"></el-option>
						<el-option label="复诊短信" :value="2" style="width:257px"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="模版名称" prop="templateName">
					<el-input size="small" placeholder="模版名称" clearable v-model="form.templateName"></el-input>
				</el-form-item>
				<el-form-item label="模版code" prop="templateCode">
					<el-input size="small" placeholder="模版code" clearable v-model="form.templateCode"></el-input>
				</el-form-item>
				<el-form-item label="模版内容" prop="templateContent">
					<el-input type="textarea" :rows="5" placeholder="请输入模版内容" v-model="form.templateContent">
					</el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" :loading="isLoading" @click="saveform">保 存</el-button>
			</div>
		</el-dialog>

	</div>
</template>

<script>
import api from '@/service/api.js';
import mixin from '@/views/mixin';

export default {
	mixins: [mixin],
	data() {
		return {
			list: {
				current: 1,
				total: 0,
				pageSize: 0,
				data: null,
			},
			filter: {
				pageNumber: 1,
				pageSize: 10,
				templateType: null
			},
			form: {
				templateCode: "",
				templateContent: "",
				templateName: '',
				templateType: ''
			},
			dlg: {
				active: false,
				title: "新增模版",

				rule: {
					templateName: {
						required: true,
						message: '请输入模版名称',
						trigger: 'blur'
					},
					templateContent: {
						required: true,
						message: '请输入模版内容',
						trigger: 'blur'
					},
					templateType: {
						required: true,
						message: '请选择短信模板',
						trigger: ['blur', 'change']
					},
					templateCode: {
						required: true,
						message: '请输入模板code',
						trigger: 'blur'
					}

				}
			},
			multipleSelection: []
		}
	},
	created() {
		this.loadList();
	},
	methods: {
		selectionChange(selected) {
			// 覆盖掉通用的
			let selection = []
			selected.forEach((item) => {
				selection.push(item);
			})
			this.multipleSelection = selection;
		},
		async loadList() {
			this.isLoading = true;
			let res = await api.queryTemplateList(this.filter)
			if (res.code == 500) {
				return this.$router.push({
					name: 'Login',
					query: {
						r: location.href
					}
				});
			}
			this.list.total = +res.total;
			this.list.current = this.filter.pageNumber;
			this.list.pageSize = Math.ceil(this.list.total / this.filter.pageSize);
			this.list.data = res.data;
			this.isLoading = false;
		},
		// 过滤条件 更改
		handleFilter(val) {
			this.filter.pageNumber = 1;
			this.loadList();
		},
		handleSizeChange(v) {
			this.filter.pageSize = v;
			this.filter.pageNumber = 1;
			this.loadList();
		},
		handleCurrentChange(v) {
			this.filter.pageNumber = v;
			this.loadList();
		},
		showDlg(type, item) {
			this.dlg.active = true;
			switch (type) {
				case 1:
					this.dlg.title = '新增模版';
					this.dlg.type = 'add';
					break;
				case 2:
					this.dlg.title = '修改模版';
					this.dlg.type = 'edit';
					this.form = { ...item }
			}
		},
		closeDlg() {
			this.dlg.active = false;
			this.form = {
				templateCode: "",
				templateContent: "",
				templateName: '',
				templateType: ''
			}
		},
		async saveform() {
			let res;
			this.$refs['form'].validate(async (valid) => {
				console.log(valid)
				if (valid) {

					if (this.dlg.type == 'add') {
						res = await api.addSmsTemplate({ ...this.form })
					} else if (this.dlg.type == 'edit') {
						res = await api.updateSmsTemplate({ ...this.form })
					}
					if (res.code == 1000) {
						this.loadList();
						this.$message({
							message: '保存成功',
							type: 'success'
						});
					} else {
						this.$message({
							message: res.message,
							type: 'error'
						});
					}
					this.closeDlg();
				}
			})
		},
		async delItem(type, item) {
			let list = [];
			let ids = ''
			this.multipleSelection.forEach(item => {
				list.push(item.id);
			})
			if (type == 'one') {
				ids = item.id
			} else {
				ids = list.join(',')
			}
			let res = await api.deleteSmsTemplate({ id: ids })
			if (res.code == 1000) {
				this.loadList();
				this.$message({
					message: '保存成功',
					type: 'success'
				});
				this.closeDlg();
			}
		}
	}
}
</script>

<style lang="less" scoped>
@import '@/assets/style/var';

/deep/.dlg-custom {
	.el-form-item {
		display: flex;
		justify-content: center;
	}

	.el-form-item__content {
		margin-left: 0 !important;
	}

	.el-input,
	.el-textarea {
		width: 257px;
	}
}

.action-bar {
	/deep/.el-button--danger {
		color: #FF6C6C;
		background-color: transparent;
	}
}

/deep/.search-bar .el-input {
	width: 180px
}



ul {
	border-bottom: 1px solid rgba(227, 227, 227, 0.5);
}

.collapse-wrap .search-bar {
	padding: 0 0 25px;
	box-shadow: none;
}

.collapse-wrap .def-key {
	padding: 20px 20px 0;
}

.collapse-wrap .table-wrap {
	margin-right: 0;
	padding: 0 20px 20px;
}</style>